import { render } from "./PlanRenewCart.vue?vue&type=template&id=54127162&scoped=true"
import script from "./PlanRenewCart.vue?vue&type=script&lang=js"
export * from "./PlanRenewCart.vue?vue&type=script&lang=js"

import "./PlanRenewCart.vue?vue&type=style&index=0&id=54127162&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54127162"]])

export default __exports__